import { api, headers } from "../../utils/authAxios";
import {
	intializeSuccess,
	isFeedbackRequired,
	saveLanguages,
	saveZones,
} from "./actions";

export const intialize = (success, fail, token) => {
	headers["user-token"] = token;
	return async (dispatch) => {
		try {
			const res = await api.post(
				"/api/game/initialize",
				{},
				{ headers: headers }
			);
			if (res?.data?.error_code === 403) {
				return fail(res.data.error_code, res.data.error_text);
			}
			// Validate token
			const validateRes = await api.post(
				"/api/game/validate-token",
				{},
				{ headers: headers }
			);
			if (validateRes?.data?.error_code === 403) {
				return fail("INVALID_TOKEN");
			}
			if (validateRes?.data?.status !== "success") {
				return fail(403, validateRes?.data?.error_text || "Not authorized Token");
			}

			dispatch(intializeSuccess(true));
			dispatch(saveLanguages(res.data.languageList));
			dispatch(saveZones(res.data.zoneList));
			dispatch(isFeedbackRequired(res.data.profileFeedbackRequired));
			success();
		} catch (error) {
			if (error?.response?.status === 403) {
				return fail("INVALID_TOKEN");
			}
			fail();
		}
	};
};
